import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "h2 text-center" }, "Ranking de Equipos", -1)
const _hoisted_3 = { class: "row justify-content-center py-10 row-cols-1 row-cols-md-2 g-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_table, {
        data: _ctx.listRanking,
        "table-layout": 'fixed',
        border: "",
        style: {"width":"100%"},
        class: "p-0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "position",
            label: "LUGAR",
            width: "100",
            align: "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "business",
            label: "EQUIPO"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_router_link, {
                to: `teams/${scope.row.abrev}`,
                class: "d-flex align-items-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_avatar, {
                    class: "img-fluid rounded-start w-30px h-30px bg-white me-2",
                    shape: "square",
                    src: `https://sismaster.perufedup.com/writable/uploads/${scope.row.avatar}`
                  }, null, 8, ["src"]),
                  _createElementVNode("span", null, _toDisplayString(scope.row.business), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "abrev",
            label: "SIGLAS",
            width: "100"
          }),
          _createVNode(_component_el_table_column, {
            prop: "score",
            label: "PUNTOS",
            width: "100",
            align: "center"
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}